import { gql } from '@apollo/client';

export const AICS_CARD_TYPES = gql`
    query aicsCardTypes {
        aicsCardTypes {
            code
            description
        }
    }
`;

export const AICS_CURRENT_ACTIVITY = gql`
    query aicsCurrentActivity {
        aicsCurrentActivity {
            id
            aics_code
            name
            feature
            discipline
        }
    }
`;

export const PRINT_AICS_CARD = gql`
    query printAICSCard($id: String!) {
        printAICSCard(id: $id) {
            filename
            content
        }
    }
`;

export const SEARCH_AICS_MUNICIPALITIES = gql`
    query searchAicsMunicipalities($query: String!, $province: String) {
        searchAicsMunicipalities(query: $query, province: $province) {
            id
            name
            province
            cap
        }
    }
`;
